module.exports = __webpack_public_path__ + "img/MTM2729-19X-華富飛魚-LOGO.bfaf7162.png";